import { RequestState } from '../../types'

export type ReportCategory = {
  id: string
  name: string
  description: string
  reports: Report[]
}

export type Report = {
  id: string
  name: string
  description: string
  params: ReportParam[]
}

export type ReportParam = {
  key: string
  type: string
  label: string
  value: ReportParamValueType
}


export type ReportParamValueType = Date | string

export type ReportsState = {
  reports: {
    reports: ReportCategory[]
    requestState: RequestState
  },
  currentReport: {
    report: undefined | Report
    requestState: RequestState
  },
  reportHtml: {
    report: undefined | string
    requestState: RequestState
  }
}

export const initialReportsState: ReportsState = {
  reports: {
    reports: [],
    requestState: RequestState.NotLoaded
  },
  currentReport: {
    report: undefined,
    requestState: RequestState.NotLoaded
  },
  reportHtml: {
    report: undefined,
    requestState: RequestState.NotLoaded
  }
}
